module.exports = __webpack_public_path__ + "static/media/analyze.85553684.webp";